<template>
  <div>
    <div class="space-x-12 dd flex items-center justify-between">
      <div
        v-for="(val, key) in items"
        :key="val"
        :class="{ active: current === val }"
        class="pb-1 px-1"
        @click="getOrderList(val)"
      >
        {{ $t(key) }}
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "@vue/composition-api";

export default {
  props: { items: Object, current_state: String },
  setup(props, ctx) {
    const current = ref(props.current_state);
    const getOrderList = (val) => {
      current.value = val;
      ctx.emit("getOrderList", val);
    };
    return { current, getOrderList };
  },
};
</script>
<style scoped lang="scss">.dd > div {
  cursor: pointer;
}
.dd > div:hover {
  display: inline-block;
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
}
.active {
  --tw-border-opacity: 1;
  border-color: rgba(21, 186, 99, var(--tw-border-opacity));
  border-bottom-width: 2px;
  padding-bottom: 2px;
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
}</style>
